<template>
    <component
      v-if="isNativeElement"
      :is="fieldComponent"
      :id="field.id"
      :value="localValue"
      @input="localValue = $event.target.value"
      :type="field.type"
      class="form-control"
    />

    <component
      v-else
      :is="fieldComponent"
      v-model="localValue"
      :id="field.id"
      :placeholder="field.placeholder"
    />
</template>

<script>
import Phone from './components/Phone.vue';

export default {
  components: { Phone },

  props: {
    field: {
      type: Object,
      required: true,
    },
    modelValue: [String, Number, Boolean, Array, Object],
  },

  computed: {
    // Manage the value (array or single value)
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },

    // Determine if the field is a native element or a custom component
    fieldComponent() {
      if (this.isNativeElement) {
        switch (this.field.type) {
          case "textarea":
            return "textarea"
          default:
            return "input"
        }
      }
      return this.field.type;
    },

     // Check if the field is a native element
    isNativeElement() {
      const nativeComponents = ["text", "textarea", "email", "number", "password", "checkbox", "radio"];
      return nativeComponents.includes(this.field.type);
    },

  }
}
</script>